 
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { FormLabel, Rating, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';
import RadioButtonCheckedRoundedIcon from '@mui/icons-material/RadioButtonCheckedRounded';
import { useFieldRequired } from './fieldRequiredContext';

const FormRadioStack = function FormRadioStack({
  name,
  defaultValue = '',
  required = false,
  label = '',
  disabled = false,
  error = null,
}) {
  const intl = useIntl();
  const { control, watch, clearErrors } = useFormContext();
  const { message = null } = error || {};
  const effectiveRequired = useFieldRequired(required);
  const watcher = watch(name);

  useEffect(() => {
    clearErrors(name);
  }, [watcher]);

  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required: effectiveRequired ? intl.messages.MANDATORY_FIELD : null,
      }}
      render={({ field: { onChange, value } }) => (
        <>
          <FormLabel
            id="rating-form-label"
            disabled={disabled}
            required={effectiveRequired}
            error={error}
          >
            {label}
          </FormLabel>
          <Rating
            id={`${name}-form-rating`}
            sx={{
              '& .MuiRating-iconFilled': {
                color: 'primary.main',
              },
              '& .MuiRating-iconHover': {
                color: 'primary.main',
              },
            }}
            defaultValue={defaultValue}
            value={value}
            onChange={onChange}
            precision={1}
            icon={
              <RadioButtonCheckedRoundedIcon
                fontSize="inherit"
                color="primary.main"
              />
            }
            emptyIcon={
              <RadioButtonUncheckedRoundedIcon
                fontSize="inherit"
                color="primary.main"
              />
            }
          />
          <FormHelperText
            sx={{
              whiteSpace: 'noWrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: 'error.main',
            }}
          >
            {message || ' '}
          </FormHelperText>
        </>
      )}
    />
  );
};

FormRadioStack.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.object,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FormRadioStack;
